"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isKette24 = exports.kette24UseableDef = void 0;
const echain_shared_modelling_1 = require("@igus/echain-shared-modelling");
const ArticleBase_1 = require("../../ArticleBase");
const echain_product_models_1 = require("@igus/echain-product-models");
exports.kette24UseableDef = {
    parent: ArticleBase_1.articleBaseUseableDef,
    validation: {
        ArticleType: (v) => v === echain_product_models_1.ArticleType.kette,
    },
};
exports.isKette24 = echain_shared_modelling_1.UseableUtil.createGuard(exports.kette24UseableDef);
//# sourceMappingURL=Kette24.js.map